import React, { useState ,useEffect, useRef} from 'react'
import { Modal } from 'react-bootstrap';
import "./CreateUserTemplate.css"
import use_default_dp from "../../../../assets/global_assets/user_imgs/user_dp_icon.png"
import { IoIosArrowDown } from "react-icons/io";
import into_icon from "../../../../assets/global_assets/create_data_imgs/into_icon.png"

  function CreateUserTemplate({ open, handleClose, roles, formValues, handleChange, handleSubmit, clientAndUnit,userData,adminUserNames,shouldShowAdminSelect }) {
    const user_data = JSON.parse(sessionStorage.getItem('user'));
    const [openImg, setOpenImg] = useState(false); ;
    const wrapperRef = useRef(null);
    const handleSelect = (user) => {
      handleChange({
        target: {
          name: "assigned_admin_id",
          value: user.user_id,
        },
      });
      setOpenImg(false);
    };
    const selectedUser = userData?.find(
      (u) => u.user_id === formValues.assigned_admin_id
    );
    
const handleKeyDown = (e) => {
  if (e.key === " " && e.target.value.length === 0) {
    e.preventDefault();
  }
};

    
    return (
      <Modal 
        show={open} 
        onHide={handleClose} 
        centered 
        dialogClassName="custom-modal-dialog"
        backdrop="static"
        keyboard={false}
        style={{ zIndex: "9999" }}
        className='bg-transparent'
      >
        <div className="row d-flex justify-content-center align-items-center w-100 bg-transparent" style={{ marginTop:"10px" }}>
          <div className="bg-white text-white " style={{padding:"5.5px",minWidth:"579px",borderRadius:"10px",overflow:"hidden",marginLeft:"22px",marginTop:"-2px"}}>
          {/* <button type="button" className="btn-close custom-btn-close" onClick={handleClose} aria-label="Close"></button> */}
          <div className="row createUserTableMainContainer rounded ">
            <div className="col-md-12">
            <div className="row">
            <div className="close-btn-div">
              <button type="button" className=" float-end bg-light  " onClick={handleClose} aria-label="Close"><img src={into_icon} alt="" /></button>
  
            </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="createFormTitle text-dark">
                    <form onSubmit={handleSubmit}>
                    <div className="title">
                      <h5>Create User</h5>
                      <p>Add a new user by providing their email and username. This allows them to access the system with the appropriate permissions.</p>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row inputdivrow">                    
                          <div className="col-md-6 inputdiv">
                            <div class="form-group">
                              <label for="user_email">Mail ID <span className="text-danger">*</span></label>
                              <input type="email" class="form-control" id="user_email" name="user_email" placeholder="abcd@gmail.com" 
                                value={formValues.user_email}
                                onChange={handleChange} onKeyDown={handleKeyDown} required/>
                            </div>
                            
                          </div>                    
                          <div className="col-md-6 inputdiv">
                            <div class="form-group">
                              <label for="user_name">User Name <span className="text-danger">*</span></label>
                              <input type="text" class="form-control" id="user_name" name="user_name" placeholder="Abcd" 
                                value={formValues.user_name}
                                onChange={handleChange} onKeyDown={handleKeyDown} required/>
                            </div>
                            
                          </div>

                        </div>
                        <div className="row inputdivrow">
                          <div className="col-md-6 inputdiv">                    
                            <div class="form-group">
                              <label for="mail_sent">Mail Notification<span className="text-danger">*</span></label>
                              <select class="" id="mail_sent" name="mail_sent"
                                value={formValues.mail_sent}
                                onChange={handleChange}
                                required
                              
                              > 
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                              </select>
                            </div>                   
                          </div>
                          <div className="col-md-6 inputdiv">                    
                            <div class="form-group">
                              <label for="role_name">Role Name<span className="text-danger">*</span></label>
                              <select class="" id="role_name" name="role_name"                                
                                value={formValues.role_name}
                                onChange={handleChange}
                                required
                              
                              > 
                                <option value="" >--select--</option>                       
                                {roles && roles.length > 0 ? (
                                roles.map((role) => (
                                    <option value={role.role_name}>
                                    {role.role_name}
                                    </option>
                                ))
                                ) : (
                                <option value="" disabled>
                                    --select--
                                </option>
                                )}
                              </select>
                            </div>                   
                          </div>
                        </div>
                        {shouldShowAdminSelect && user_data.base_role == "SuperAdmin" && (
                          <div className="col-md-12" style={{ marginTop:"-4px" }}>
                            <div className="form-group reporting-manager position-relative" ref={wrapperRef}>
                              <label htmlFor="assigned_admin_id" className="form-label">
                                Reporting Manager
                              </label>

                              <div
                                className="rm-selected d-flex justify-content-between align-items-center "
                                onClick={() => setOpenImg(!openImg)}
                              >
                                {selectedUser ? (
                                  <div className="rm-selected-content d-flex align-items-center gap-2">
                                    <img
                                      src={selectedUser.dp || use_default_dp}
                                      alt="dp"
                                      onError={(e) => (e.target.src = use_default_dp)}
                                    />
                                    <span>{selectedUser.user_name}</span>
                                  </div>
                                ) : (
                                  <span className="rm-placeholder">--select--</span>
                                )}
                                <span className='arrowicondropdown'><IoIosArrowDown /></span>
                              </div>

                              {openImg && (
                                <div className="rm-dropdown border rounded bg-white shadow-sm mt-1">
                                  {userData.filter(item => adminUserNames.includes(item.role_name)).map((item) => (
                                    <div
                                      key={item.user_id}
                                      className="rm-option d-flex align-items-center gap-2 p-2"
                                      onClick={() => handleSelect(item)}
                                    >
                                      <img
                                        src={item.dp || use_default_dp}
                                        alt="dp"
                                        onError={(e) => (e.target.src = use_default_dp)}
                                      />
                                      <span>{item.user_name}</span>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>  
                        )}
                        <div className="col-md-12 mt-4 ">
                          <button className=" w-100 btn formSubmitBtn" type='submit'>Submit</button>
                          </div>                 
                      </div>
                    </div>
                    </form>
                </div>
              </div>
            </div>
            </div>
          </div>
          </div>
        </div>
      </Modal>

    );
  }

  export default CreateUserTemplate;

